import { useCanonicalUrl, Div, Text, ShareLinks, EditorialArticleNavigationList } from '@cbhq/cdx-components';
import { useContentfulMicrocopy } from '../../../globals/microcopy.js';
import { jsx, jsxs } from 'react/jsx-runtime';
function DesktopSidebar({
  anchors = [],
  showSocialSharingLinks
}) {
  const canonicalUrl = useCanonicalUrl();
  const microcopies = useContentfulMicrocopy();
  return /*#__PURE__*/jsx(Div, {
    flexDirection: "column",
    spacingTop: 8,
    spacingBottom: 2,
    as: "aside",
    children: /*#__PURE__*/jsxs(Div, {
      flexDirection: "column",
      borderColor: "line",
      children: [showSocialSharingLinks && /*#__PURE__*/jsxs(Div, {
        flexDirection: "column",
        spacingStart: 4,
        spacingBottom: 4,
        children: [/*#__PURE__*/jsx(Text, {
          variant: "legal",
          as: "p",
          color: "foregroundMuted",
          spacingBottom: 1,
          children: microcopies.global?.share
        }), canonicalUrl && /*#__PURE__*/jsx(ShareLinks, {
          canonicalUrl: canonicalUrl
        })]
      }), anchors.length > 1 && /*#__PURE__*/jsx(EditorialArticleNavigationList, {
        quickScrollContent: anchors
      })]
    })
  });
}
export { DesktopSidebar };
//# sourceMappingURL=DesktopSidebar.js.map
